
import React from 'react';

const WhyUsSection = () => {
  return (
    <section className="bg-gray-50 py-16">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="max-w-4xl mx-auto text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-primary mb-8">
            Why Us
          </h2>
          
          <div className="text-lg text-gray-700 space-y-6 leading-relaxed">
            <p>
              At Law and Code Africa, we publish considered commentary at the meeting point of
              technology, commerce, and the law. Our work spans emerging tech regulation,
              corporate and commercial practice, and the everyday legal questions facing
              businesses operating in a digital economy.
            </p>

            <p>
              We pay close attention to how statutory provisions, contractual practice, and
              regulatory developments shape commercial activity, from intellectual property
              and corporate governance to data, platforms, and dispute resolution. The aim is
              practical clarity for founders, in-house teams, and practitioners navigating
              modern markets.
            </p>

            <p>
              Tech and commerce sit side by side in our coverage. Whether the question is a
              new technology rule, a commercial contract, or a governance dilemma, we focus
              on commentary that is rigorous, accessible, and grounded in African commercial
              realities.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyUsSection;
